<template>
    <div class="page">
        <div v-for="(item,index) in dataCategory" :key="index">
            <!-- 第一层 -->
            <div class="one_level">
                <span @click="getItem(item)">{{item.name}}</span>
                <div class="img_box" @click="openColl(item)">
                    <!-- <img src="../../../assets/icon_down.png" /> -->
                    <img :src="item.disabled?require('../img/icon_up.png'):require('../img/icon_down.png')" />
                </div>
            </div>
            <!--v-show配合标签的隐藏和显示-->
            <div class="container" v-show="item.disabled">
                <div v-if="item.children">
                    <div v-for="(item2,index2) in item.children" :key="index2">
                        <!-- 第三层 -->
                        <div v-if="item2.children">
                            <div class="one_level">
                                <span @click="getItem(item2)">{{item2.name}}</span>
                                <div class="img_box" @click="openColl(item2)">
                                    <!-- <img src="../../../assets/icon_down.png" /> -->
                                    <img :src="item2.disabled?require('../img/icon_up.png'):require('../img/icon_down.png')" />
                                </div>
                            </div>
                            <!-- z子内容 -->
                            <div v-for="(item3,index3) in item2.children" :key="index3">
                                <div class="two_level" v-show="item2.disabled" @click="getItem(item3)">
                                    {{item3.name}}
                                </div>
                            </div>
                            <!-- <div class="two_level" v-show="item2.disabled" @click="getItem(item2.children[0])">
                                {{item2.children[0].name}}
                            </div> -->
                        </div>
                        <!-- 第二层 -->
                        <div v-else>
                            <div class="one_level" @click="getItem(item2)">{{item2.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import { getCategory, getDetail } from "@/api/helpCenter";
    export default {
        data() {
            return {
                dataCategory: [],
                testA: [{"id":12,"name":"测试1","pid":0,"spacer":"","childlist":[{"id":15,"name":"测试1-1","pid":12,"spacer":" ├","childlist":[{"id":16,"name":"测试2-1","pid":15,"spacer":" │ └","childlist":[],"disabled":false,"key":"15.16"}],"children":[{"id":16,"name":"测试2-1","pid":15,"spacer":" │ └","childlist":[],"disabled":false,"key":"15.16"}],"key":"12.15","disabled":false},{"id":17,"name":"测试1-2","pid":12,"spacer":" └","childlist":[{"id":18,"name":"测试1-2-1","pid":17,"spacer":"   ├","childlist":[],"disabled":false,"key":"17.18"},{"id":20,"name":"测试1-2-2","pid":17,"spacer":"   └","childlist":[],"disabled":false,"key":"17.20"}],"children":[{"id":18,"name":"测试1-2-1","pid":17,"spacer":"   ├","childlist":[],"disabled":false,"key":"17.18"},{"id":20,"name":"测试1-2-2","pid":17,"spacer":"   └","childlist":[],"disabled":false,"key":"17.20"}],"key":"12.17","disabled":false}],"children":[{"id":15,"name":"测试1-1","pid":12,"spacer":" ├","childlist":[{"id":16,"name":"测试2-1","pid":15,"spacer":" │ └","childlist":[],"disabled":false,"key":"15.16"}],"children":[{"id":16,"name":"测试2-1","pid":15,"spacer":" │ └","childlist":[],"disabled":false,"key":"15.16"}],"key":"12.15","disabled":false},{"id":17,"name":"测试1-2","pid":12,"spacer":" └","childlist":[{"id":18,"name":"测试1-2-1","pid":17,"spacer":"   ├","childlist":[],"disabled":false,"key":"17.18"},{"id":20,"name":"测试1-2-2","pid":17,"spacer":"   └","childlist":[],"disabled":false,"key":"17.20"}],"children":[{"id":18,"name":"测试1-2-1","pid":17,"spacer":"   ├","childlist":[],"disabled":false,"key":"17.18"},{"id":20,"name":"测试1-2-2","pid":17,"spacer":"   └","childlist":[],"disabled":false,"key":"17.20"}],"key":"12.17","disabled":false}],"key":"0.12","disabled":false},{"id":13,"name":"测试2","pid":0,"spacer":"","childlist":[],"disabled":false,"key":"0.13"},{"id":14,"name":"测试3","pid":0,"spacer":"","childlist":[],"disabled":false,"key":"0.14"}]
            }
        },
        created() {
            this.getData()
        },
        methods: {
            //获取分类
            getData() {
                getCategory().then((res) => {
                    this.dataCategory = this.handleData(res.data)

                })
            },
            //处理目录树
            handleData(list) {
                let resultData = list.map((item) => {
                    if (item.childlist.length != 0) {
                        item.children = item.childlist
                        item.key = item.pid + '.' + item.id
                        item.disabled = false
                        this.handleData(item.childlist, [])
                        // delete item['childlist']
                        return item

                    } else {
                        item.disabled = false
                        item.key = item.pid + '.' + item.id
                        // delete item['childlist']
                        return item
                    }
                })
                // console.log("目录树", JSON.stringify(resultData))
                return resultData;
            },
            //点击图标
            openColl(text) {
                console.log("重置目录")
                this.dataCategory = this.switchDataVersonName(this.dataCategory, text)
                // this.testA = this.switchDataVersonName(this.testA, text)
            },
            // 递归过滤
            switchDataVersonName(column, text) {
                column.forEach(item => {
                    if (item.id === text.id) {
                        item.disabled = !item.disabled
                    } else if (item.children) {
                        this.switchDataVersonName(item.children, text)
                    }
                });
                console.log("重置目录完成",column)
                return column
            },
            getItem(item) {
                getDetail({ helpCategoryId: item.id }).then((res) => {
                    if (res.code == 200) {
                        if (res.data.length != 0) {
                            this.$emit("conback", res.data)
                        } else {
                            this.$toast('暂无内容');
                        }
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/.van-cell__right-icon {
        display: none;
    }

    /deep/.van-collapse-item--border::after {
        border-top: none !important;
    }

    /deep/.van-cell::after {
        border-bottom: none !important;
    }

    .page {
        width: 100%;
        padding: 11px 14px;
    }

    .title_head {
        font-size: 14px;
        font-weight: bold;
        color: #02134A;
    }

    .title_con {
        font-size: 14px;
        font-weight: bold;
        color: #3974C6;
    }

    .one_level {
        padding: 13px 0;
        font-size: 14px;
        font-weight: bold;
        color: #02134A;
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
        cursor: pointer;
        .img_box{
            width: 40px;
            height: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
            width: 9px;
            height: 5px;
        }
        }
       
    }

    /deep/.van-cell__title {
        font-size: 14px !important;
        font-weight: bold;
        color: #3974C6 !important;
    }

    .two_level {
        padding: 0.26667rem 0.42667rem;
        overflow: hidden;
        color: #3974C6;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        cursor: pointer;
    }

    .three_level {
        font-size: 14px;
        font-weight: 400;
        color: #3974C6;
        cursor: pointer;
        padding: 0.26667rem 0.42667rem;
    }

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1em;
    }

    .title h4 {
        line-height: 2;
        margin: 0;
    }

    .container {
        padding: 0 1em;
    }

    .btn {
        /* 鼠标改成手的形状 */
        cursor: pointer;
    }
</style>